export default __webpack_public_path__ + "static/media/jacuzzi.1ed1ce53.svg";